import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7153e818"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "c-modal-cover"
}
const _hoisted_2 = { class: "c-modal-header" }
const _hoisted_3 = { class: "c-modal-title" }
const _hoisted_4 = { class: "c-modal-icons" }
const _hoisted_5 = { class: "c-modal-footer" }
const _hoisted_6 = { calss: "c-modal-footer-btns" }

import CButton from '../cButton/CButton.vue';
interface ModalProps {
  width?: number,
  height?: number,
  title?: string,
  visible: boolean,
  centered?: boolean
}

const __default__ = {
  name:'CModal'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    width: { default: 600 },
    height: null,
    title: null,
    visible: { type: Boolean },
    centered: { type: Boolean, default: false }
  },
  emits: ['update:visible'],
  setup(__props: any, { emit }) {

const props = __props as { width: number, height?: number, title?: string, visible: boolean, centered: boolean };



const closeModal = () => {
  emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "c-modal-container",
          style: _normalizeStyle('width:' + __props.width + 'px;height:' + __props.height + 'px')
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_svg_icon, {
                icon: "close",
                onClick: closeModal
              })
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["c-modal-body", { 'flex-center': __props.centered }])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "footer", {}, () => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_button, { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}
}

})